// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__13NWM","addWidgetButton":"Header_addWidgetButton__2kjRg","dashboardTabs":"Header_dashboardTabs__3dvjH","active":"Header_active__1jTGm"};